import React from 'react';
import { Modal } from 'antd';

import Button from 'components/Button';
import DF from 'DisplayFramework';
import GuarantDetail from '.';

type GuarantDetailModalProps = {
    onCancel: () => void;
    guarId?: string;
    visible: boolean;
    title: string;
    onSuccess?: () => void;
    isProposalCreate?: boolean;
    iscreate?: boolean;
};

const GuarantDetailModal = (props: GuarantDetailModalProps) => {
    const {
        onCancel,
        guarId,
        visible,
        title,
        iscreate,
    } = props;

    return (
        (<DF.Provider pagcode="tpdetail">
            <Modal
                open={visible}
                onCancel={onCancel}
                width={1400}
                title={title}
                footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
                
            >
                <GuarantDetail iscreate={iscreate} guarId={guarId} />
            </Modal>
        </DF.Provider>)
    );
};

export default GuarantDetailModal;
